import UserProgressDao from '../dao/user-progress.dao';
import type { Environment } from '../interfaces/environment';
import type { UserProgress } from '../interfaces/user-progress';

export abstract class UserProgressService {
  static getUserProgress(
    env: Environment,
    personId: number
  ): Promise<UserProgress> {
    return UserProgressDao.getUserProgress(env, personId);
  }
}
